module.exports = __webpack_public_path__ + "img/symbol-euro-left.7975835a.png";